/**
 * Models the workflow builder's Text Generation node may run through
 * /api/generate-text. The route accepts ONLY these values (it used to pass
 * any string straight to the provider) and lets a Free plan use only the
 * FREE set — the same posture as the Marky chat gate.
 */
export const TEXT_MODELS = [
  // GPT-6 (latest)
  { value: 'gpt-6-astra', label: 'GPT-6 Astra' },
  { value: 'gpt-6.1-sol', label: 'GPT-6.1 Sol' },
  { value: 'gpt-6-sol', label: 'GPT-6 Sol' },
  { value: 'gpt-6-luna', label: 'GPT-6 Luna' },
  { value: 'gpt-5.6-sol', label: 'GPT-5.6 Sol' },
  { value: 'gpt-5.6-terra', label: 'GPT-5.6 Terra' },
  { value: 'gpt-5.6-luna', label: 'GPT-5.6 Luna' },
  // GPT-5.5
  { value: 'gpt-5.5-instant', label: 'GPT-5.5 Instant' },
  { value: 'gpt-5.5-thinking', label: 'GPT-5.5 Thinking' },
  { value: 'gpt-5.5-pro', label: 'GPT-5.5 Pro' },
  // GPT-5.4
  { value: 'gpt-5.4-instant', label: 'GPT-5.4 Instant' },
  { value: 'gpt-5.4-thinking', label: 'GPT-5.4 Thinking' },
  { value: 'gpt-5.4-pro', label: 'GPT-5.4 Pro' },
  // GPT-5.2
  { value: 'gpt-5.2-instant', label: 'GPT-5.2 Instant' },
  { value: 'gpt-5.2-thinking', label: 'GPT-5.2 Thinking' },
  { value: 'gpt-5.2-pro', label: 'GPT-5.2 Pro' },
  // GPT-5.1
  { value: 'gpt-5.1-instant', label: 'GPT-5.1 Instant' },
  { value: 'gpt-5.1-thinking', label: 'GPT-5.1 Thinking' },
  { value: 'gpt-5.1-pro', label: 'GPT-5.1 Pro' },
  // GPT-5
  { value: 'gpt-5', label: 'GPT-5' },
  { value: 'gpt-5-mini', label: 'GPT-5 Mini' },
  { value: 'gpt-5-nano', label: 'GPT-5 Nano' },
  { value: 'gpt-5-codex', label: 'GPT-5 Codex' },
  { value: 'gpt-5-chat-latest', label: 'GPT-5 Chat Latest' },
  // Claude
  { value: 'claude-fable-5-1', label: 'Claude Fable 5.1' },
  { value: 'claude-fable-5', label: 'Claude Fable 5' },
  { value: 'claude-opus-5-5', label: 'Claude Opus 5.5' },
  { value: 'claude-opus-5', label: 'Claude Opus 5' },
  { value: 'claude-opus-4-8', label: 'Claude Opus 4.8' },
  { value: 'claude-opus-4-7', label: 'Claude Opus 4.7' },
  { value: 'claude-opus-4-6', label: 'Claude Opus 4.6' },
  { value: 'claude-opus-4-5', label: 'Claude Opus 4.5' },
  { value: 'claude-sonnet-5-5', label: 'Claude Sonnet 5.5' },
  { value: 'claude-sonnet-5', label: 'Claude Sonnet 5' },
  { value: 'claude-sonnet-4-6', label: 'Claude Sonnet 4.6' },
  { value: 'claude-sonnet-4-5', label: 'Claude Sonnet 4.5' },
  { value: 'claude-haiku-4-5', label: 'Claude Haiku 4.5' },
  // Gemini
  { value: 'gemini-3.8-flash', label: 'Gemini 3.8 Flash' },
  { value: 'gemini-3.7-flash', label: 'Gemini 3.7 Flash' },
  { value: 'gemini-3.1-pro-preview', label: 'Gemini 3.1 Pro' },
  { value: 'gemini-3-pro-preview', label: 'Gemini 3 Pro' },
  { value: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash' },
] as const;

export type WorkflowTextModel = (typeof TEXT_MODELS)[number]['value'];

export const WORKFLOW_TEXT_MODEL_VALUES: readonly string[] = TEXT_MODELS.map(
  (m) => m.value,
);

/** The cheap tier a Free plan may run in workflows. */
export const WORKFLOW_TEXT_MODELS_FREE: ReadonlySet<string> = new Set([
  'gpt-5.4-instant',
  'gpt-5-mini',
  'gpt-5-nano',
  'gpt-5-chat-latest',
  'claude-haiku-4-5',
  'gemini-3.8-flash',
  'gemini-3.7-flash',
  'gemini-2.5-flash',
]);

export const isWorkflowTextModel = (
  value: unknown,
): value is WorkflowTextModel =>
  typeof value === 'string' && WORKFLOW_TEXT_MODEL_VALUES.includes(value);
